<script lang="ts">
  import { Link } from 'carbon-components-svelte';
  import type { DataTableRow } from 'carbon-components-svelte/src/DataTable/DataTable.svelte';

  import type { CellRenderer } from './cell-renderers';
  import type { TableColumn } from './table-types';

  export let cell: { key: string; value: unknown },
    row: DataTableRow,
    column: TableColumn | undefined = undefined,
    renderer: CellRenderer | undefined = undefined;

  const cellStyle = (col?: TableColumn): string | undefined => {
    const parts: string[] = [];
    if (col?.maxWidth) parts.push(`max-width: ${col.maxWidth}`);
    if (col?.minWidth) parts.push(`min-width: ${col.minWidth}`);
    return parts.length ? parts.join('; ') : undefined;
  };

  $: href = column?.url?.(row);
  $: value = column?.display ? column.display(row) : cell.value;
</script>

<span
  class="cell-content"
  class:cell-content--ellipsis={Boolean(column?.maxWidth)}
  class:cell-content--nowrap={Boolean(column?.noWrap)}
  style={cellStyle(column)}
  title={column?.maxWidth ? String(value ?? '') : undefined}
>
  {#if href}
    <Link {href} target="_blank" rel="noopener noreferrer">{value ?? '—'}</Link>
  {:else if renderer}
    <svelte:component this={renderer.component} {...renderer.getProps(cell.value, row)} />
  {:else}
    {value ?? '—'}
  {/if}
</span>

<style>
  .cell-content {
    display: block;
    min-width: 0;
  }

  .cell-content--ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .cell-content--nowrap {
    white-space: nowrap;
  }

  .cell-content--ellipsis :global(.bx--link) {
    display: block;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>
